import AdminGuard from '@/views/dashboard/guards/AdminGuard'
import Help from './Help'
import ManageHelp from './ManageHelp'
import CreateHelp from './CreateHelp'
import EditHelp from './EditHelp'

export default [
    { path: 'bantuan', component: Help, name: 'help', meta: { title: 'Bantuan' } },
    { path: 'bantuan/kelola', component: ManageHelp, beforeEnter: AdminGuard, name: 'help.manage', meta: { title: 'Kelola Bantuan' } },
    { path: 'bantuan/buat', component: CreateHelp, beforeEnter: AdminGuard, name: 'help.create', meta: { title: 'Buat Bantuan'} },
    { path: 'bantuan/edit/:help_id', component: EditHelp, beforeEnter: AdminGuard, name: 'help.edit', meta: { title: 'Edit Bantuan' } },
]
